import { generatePath } from 'react-router-dom';

import { AdminDashboardUserStatus, AdminViewsUser } from '@/api/admin/types';
import { PagePaths } from '@/routes/page-paths';

export type UserTabTableRow = AdminViewsUser & {
  key: string;
  nameWithAlias: string;
  href?: string;
};

export const isPendingInvitee = (user: AdminViewsUser) =>
  user.statuses.includes(AdminDashboardUserStatus.Pending);

export const toUserTabTableRow = (user: AdminViewsUser): UserTabTableRow => ({
  ...user,
  key: user.id,
  invitationTypes: user.invitationTypes ?? [],
  nameWithAlias:
    user.name && user.alias ? `${user.name} (${user.alias})` : user.name || user.alias || '-',
  href: isPendingInvitee(user) ? undefined : generatePath(PagePaths.userProfile, { id: user.id }),
});
